import { createAction, props } from '@ngrx/store';

export const setImpacts = createAction(
    '[Set Impacts] Set Impacts',
    props<{impacts: any[]}>()
);

export const unsetImpacts = createAction('[Unset Impacts] Unset Impacts');
